import React, { useEffect, useState } from "react";
import AboutIpo from "../components/AboutIpo";
import FirstFoldIpo from "./FirstFoldIpo";
import WhyIpo from "./WhyIpo";
import MldMarketingFaq from "./MldMarketingFaq";
import { mldInvest } from "../assets/constants/mld-invest";
import { ipoInvest } from "../assets/constants/ipo-invest";
import moment from "moment";
import WLTransactionHistory from "./WLTransactionHistory";
import { cancleBidIpo, updateStatus } from "../services/waitlist-service";
import { toast } from "react-toastify";
import ReactGA from "react-ga4";
import { setAnalyticsEvent } from "../../core/helpers/analytics";
import { OroLoaderInline } from "../../core";
import CancelBidPopUp from "./CancelBidPopUp";
import { Col, Row } from "reactstrap";
import ResourceFold from "./ResourceFold";
import DynamicTable from "./DynamicTable";
import { getFaq } from '../services/waitlist-service';

export default function IpoAssetNew(props) {
    const [loader, setLoader] = useState(true);
    const [issueList, setIssueList] = useState({});
    const [series, setSeries] = useState();
    const [showCancelBid, setShowCancelBid] = useState(false);
    const [orderId, setOrderId] = useState();
    const [disableCancel, setDisableCancel] = useState(true);
    const [bondfaq, setBondFaq] = useState();
    const [result, setResult] = useState();
    const [isSection, setIsSection] = useState(true); // this page need faq sections
    
    useEffect(() => {
        getFaq('bonds', props.product).then((response) => {
          if (!response.success) {
            return toast.error(response.message)
          } else {
            setBondFaq(response?.data?.questions)
          }
        })
      }, []);
    
      useEffect(() => {
        if(!isSection && bondfaq){
          // flat data without section
          const allContentArrays = bondfaq.map(item => item.content).flat();
          setResult(allContentArrays);
        } else {
          // data with section
          setResult(bondfaq); 
        }
      }, [bondfaq])    

    useEffect(() => {
        const locationHash = window.location.hash;
        ReactGA.send({ hitType: "pageview", page_location: `${locationHash}` });
        { process.env.REACT_APP_RENDER_GA === "true" &&
            setAnalyticsEvent(locationHash, `${locationHash}`);
        }
    }, []);

    useEffect(() => {
        if (
            props.ipoAssetDetails &&
            Object.keys(props.ipoAssetDetails).length
        ) {
            setLoader(false);
        }
        const issueListTemp = [
            {
                point: "Open Date",
                explaination:
                    moment(props?.ipoAssetDetails?.openDate).format(
                        "Do MMM YYYY"
                    ) || "--",
            },
            {
                point: "Close Date",
                explaination:
                    moment(props?.ipoAssetDetails?.closeDate).format(
                        "Do MMM YYYY"
                    ) || "--",
            },
            {
                point: "YTM",
                explaination: props?.ipoAssetDetails?.xirr
                    ? props?.ipoAssetDetails?.xirr + "%"
                    : "--",
            },
            {
                point: "Min. Investment Amount",
                explaination: props?.ipoAssetDetails?.minAmt
                    ? "₹" + props?.ipoAssetDetails?.minAmt
                    : "--",
            },
            {
                point: "Principal Payout",
                explaination: props?.ipoAssetDetails?.principalRepayment
                    ? props?.ipoAssetDetails?.principalRepayment
                    : "--",
            },
            {
                point: "Interest Payout",
                explaination: props?.ipoAssetDetails?.couponType || "--",
            },
        ];
        setSeries(props?.ipoAssetDetails?.series);
        setIssueList(issueListTemp);
    }, [props.ipoAssetDetails]);

    const HandleCancleBid = () => {
        let payload = {
            orderId: orderId,
        };
        cancleBidIpo(
            { "X-product": `orobonds:${props.ipoAssetDetails.product}` },
            payload
        ).then(
            (res) => {
                if (res.success) {
                    window.location.reload();
                }
                if (!res.success) {
                    toast.error(res.message);
                }
            },
            (err) => {
                toast.error("err", err);
            }
        );
    };

    const getUpdateStatus = (bids, e) => {
        e.preventDefault()
        console.log("clicked")
        let payload = {
            orderId: bids,
        };
        updateStatus(
            { "X-product": `orobonds:${props.ipoAssetDetails.product}` },
            payload
        ).then(
            (res) => {
                if (res.success) {
                    console.log(props?.recallTransaction());
                }
                if (!res.success) {
                    toast.error(res.message);
                }
            },
            (err) => {
                toast.error("err", err);
            }
        );
    };
    const toggleCancel = (orderId) => {
        setOrderId(orderId);
        setShowCancelBid(!showCancelBid);
    };

    const cancelBidHandle = () =>{
        setDisableCancel(false)
      }

    if (loader) {
        return (
            <div className="w-100 h-100">
                <OroLoaderInline />
            </div>
        );
    }

    return (
        <>

            <div className="ipo-page">
                <FirstFoldIpo
                    issueList={issueList}
                    ipoAssetDetails={props.ipoAssetDetails}
                    goToPaymentOverview={props.startInvest}
                    staticContent={ipoInvest}
                    isMobile={props?.isMobile}
                    cancelBidHandle={cancelBidHandle}
                />

                {props.transactions.length > 0 && props?.productDetails && props.portfolioValue &&
                    <WLTransactionHistory
                        isMobile={props.isMobile}
                        transactions={props.transactions}
                        portfolio={props.portfolioValue}
                        productDetails={props?.productDetails}
                        HandleCancleBid={HandleCancleBid}
                        getUpdateStatus={getUpdateStatus}
                        series={series}
                        toggleThankYou={toggleCancel}
                        disableCancel={disableCancel}
                    />}

                <Col className="how-to">
                    <div className="how-to__wrapper">
                        <h2 className="text-center mb-0 how-to__title">
                            {ipoInvest.ipo.title}
                        </h2>
                        <p className="text-center how-to__desc">
                            {ipoInvest.ipo.subtitle}
                        </p>

                        <Row xs="2" md="4" className="mt-4">
                            {ipoInvest.ipo.highlights.map((item) => (
                                <Col className="how-to__step w-100">
                                    <p className="text-center how-to__step-title mb-2 mb-md-3">
                                        {item.step}
                                    </p>
                                    <div className="d-flex how-to__step-icon position-relative justify-content-center">
                                        <img src={item.img} alt=""/>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="191"
                                            height="16"
                                            viewBox="0 0 191 16"
                                            fill="none"
                                        >
                                            <path
                                                d="M190.207 8.70711C190.598 8.31658 190.598 7.68342 190.207 7.29289L183.843 0.928932C183.453 0.538408 182.819 0.538408 182.429 0.928932C182.038 1.31946 182.038 1.95262 182.429 2.34315L188.086 8L182.429 13.6569C182.038 14.0474 182.038 14.6805 182.429 15.0711C182.819 15.4616 183.453 15.4616 183.843 15.0711L190.207 8.70711ZM0 9H1.97396V7H0V9ZM5.92188 9H9.86979V7H5.92188V9ZM13.8177 9H17.7656V7H13.8177V9ZM21.7135 9H25.6615V7H21.7135V9ZM29.6094 9H33.5573V7H29.6094V9ZM37.5052 9H41.4531V7H37.5052V9ZM45.401 9H49.349V7H45.401V9ZM53.2969 9H57.2448V7H53.2969V9ZM61.1927 9H65.1406V7H61.1927V9ZM69.0885 9H73.0365V7H69.0885V9ZM76.9844 9H80.9323V7H76.9844V9ZM84.8802 9H88.8281V7H84.8802V9ZM92.776 9H96.724V7H92.776V9ZM100.672 9H104.62V7H100.672V9ZM108.568 9H112.516V7H108.568V9ZM116.464 9H120.411V7H116.464V9ZM124.359 9H128.307V7H124.359V9ZM132.255 9H136.203V7H132.255V9ZM140.151 9H144.099V7H140.151V9ZM148.047 9H151.995V7H148.047V9ZM155.943 9H159.891V7H155.943V9ZM163.839 9H167.786V7H163.839V9ZM171.734 9H175.682V7H171.734V9ZM179.63 9H183.578V7H179.63V9ZM187.526 9H189.5V7H187.526V9Z"
                                                fill="#979797"
                                            />
                                        </svg>
                                    </div>
                                    <p className="text-center mt-2 mt-md-4 how-to__step-desc">
                                        {item.text}
                                    </p>
                                </Col>
                            ))}
                        </Row>
                    </div>
                </Col>

                <AboutIpo
                    productDetails={props?.productDetails}
                    mldAssetDetails={props?.ipoAssetDetails}
                    aboutIcm={mldInvest && mldInvest.aboutIncred}
                />

                <DynamicTable data={ipoInvest.ipo.Source_Fold} />

                <WhyIpo
                    mldAssetDetails={props.ipoAssetDetails}
                    whyIcm={mldInvest && mldInvest.whyIcm}
                />

                <ResourceFold
                    mldAssetDetails={props.ipoAssetDetails}
                    fromBondsPage={true}
                    forIpo={true}
                />

                <MldMarketingFaq mldMarketingFaq={result} />

                {showCancelBid && (
                    <CancelBidPopUp
                        close={process.env.REACT_APP_IMAGES_PATH + "close.webp"}
                        showCancelBid={showCancelBid}
                        toggleThankYou={toggleCancel}
                        HandleCancleBid={HandleCancleBid}
                    />
                )}
            </div>
        </>
    );
}
